export const SELECTIONS = 'selections'
export const QUESTION_ID = 'question_id'
export const QUESTION_TEXT = 'question_text'
export const REQUIRED_OR_OPTIONAL = 'required_or_optional'
export const REQUIRED = 'required'
export const OPTIONAL = 'optional'
